import { Box, darken, lighten, Stack, Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';
import bgimage from './small_business_owners_at_laptop.png';
import ChangeEnv from 'components/change-env/change-env.component';
import ThemeSwitch from 'components/theme-switch/theme-switch.component';

const UnauthenticatedLayout = () => {
  return (
    <Box
      display="grid"
      gridTemplateColumns={{ xs: '0fr 1fr', lg: '3fr 2fr' }}
      height="100%"
    >
      <Box
        position="relative"
        top={0}
        left={0}
        right={0}
        bottom={0}
        bgcolor={theme =>
          theme.palette.mode === 'light'
            ? lighten(theme.palette.background.default, 0.5)
            : darken(theme.palette.background.default, 0.5)
        }
        sx={{
          backgroundImage: `url(${bgimage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      ></Box>
      <Toolbar sx={{ position: 'fixed', top: 0, right: 0 }}>
        <Stack direction="row" spacing={1}>
          <ChangeEnv />
          <ThemeSwitch />
        </Stack>
      </Toolbar>
      <Box
        p={4}
        display="flex"
        height="100%"
        alignItems="center"
        justifySelf="center"
      >
        <Outlet />
      </Box>
    </Box>
  );
};
export default UnauthenticatedLayout;
